<template>
    <div class="d-flex justify-content-between overflow-x-auto">
        <flip class="me-3">
            <template #default>
                <div class="text-center text-primary">
                    <div class="mb-3">
                        <house-icon :size="48"/>
                    </div>
                    Fully Vetted<br />
                    and Stocked
                </div>
            </template>
            <template #on>
                <div class="x-small">
                    <p class="fw-bold small">Fully Vetted and Stocked</p>
                    Every property is meticulously inspected and equipped with high-quality amenities to ensure your stay is comfortable and seamless.
                </div>
            </template>
        </flip>
        <flip class="me-3">
            <template #default>
                <div class="text-center text-primary">
                    <div class="mb-3">
                        <room-icon :size="48"/>
                    </div>
                    In-Stay<br />
                    Housekeeping
                </div>
            </template>
            <template #on>
                <div class="x-small">
                    <p class="fw-bold small">In-Stay Housekeeping</p>
                    Enjoy the luxury of professional housekeeping services during your stay to maintain the pristine condition of your accommodation.
                </div>
            </template>
        </flip>
        <flip class="me-3">
            <template #default>
                <div class="text-center text-primary">
                    <div class="mb-3">
                        <star-circle-icon :size="48"/>
                    </div>
                    Premium Home<br />
                    Preparation
                </div>
            </template>
            <template #on>
                <div class="x-small">
                    <p class="fw-bold small">Premium Home Preparation</p>
                    Prior to your arrival, each property undergoes a thorough preparation process to meet exceptional standards of cleanliness and comfort.
                </div>
            </template>
        </flip>
        <flip class="me-3">
            <template #default>
                <div class="text-center text-primary">
                    <div class="mb-3">
                        <bell-icon :size="48"/>
                    </div>
                    Curated Concierge<br />
                    Partners
                </div>
            </template>
            <template #on>
                <div class="x-small">
                    <p class="fw-bold small">Curated Concierge Partners</p>
                    Access our exclusive list of local vendors, carefully selected for their exceptional service and reliability.
                </div>
            </template>
        </flip>
        <flip>
            <template #default>
                <div class="text-center text-primary">
                    <div class="mb-3">
                        <clock-forward-icon :size="48"/>
                    </div>
                    Around the<br />
                    Clock Support
                </div>
            </template>
            <template #on>
                <div class="x-small">
                    <p class="fw-bold small">Around the Clock Support</p>
                    Receive 24/7 assistance for any inquiries or issues, providing you with peace of mind and immediate support whenever needed.
                </div>
            </template>
        </flip>
    </div>
</template>
<script type="text/javascript">
    import HouseIcon from '@/assets/icons/house.svg.vue';
    import RoomIcon from '@/assets/icons/room.svg.vue';
    import BellIcon from '@/assets/icons/bell.svg.vue';
    import StarCircleIcon from '@/assets/icons/star-circle.svg.vue';
    import ClockForwardIcon from '@/assets/icons/clock-forward.svg.vue';

    import CommonComponents from '@/components/Common.vue';

    export default {
        components: {
            HouseIcon,
            RoomIcon,
            BellIcon,
            StarCircleIcon,
            ClockForwardIcon,
            ...CommonComponents,
        },
    };

</script>